import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PaystackButton } from './PaystackButton';
import { Check, Mail } from 'lucide-react';
export function PricingSection() {
  const [email, setEmail] = useState('');
  const [showEmailInput, setShowEmailInput] = useState(false);
  const navigate = useNavigate();
  const handleEnrollClick = () => {
    setShowEmailInput(true);
  };
  const handlePaymentSuccess = (reference: string) => {
    // Redirect to enrollment form page after successful payment
    navigate('/enrollment-form');
  };
  const handlePaymentClose = () => {
    console.log('Payment window closed');
  };
  return <div className="bg-white rounded-2xl shadow-xl border-2 border-blue-100 p-8 sticky top-24" data-id="element-365">
      <div className="mb-6" data-id="element-366">
        <div className="flex items-baseline gap-2 mb-2" data-id="element-367">
          <span className="text-4xl font-bold text-gray-900" data-id="element-368">₦150,000</span>
          <span className="text-gray-600" data-id="element-369">/ $100</span>
        </div>
        <p className="text-sm text-gray-600" data-id="element-370">
          One-time payment for full course access
        </p>
      </div>

      <div className="space-y-4 mb-8" data-id="element-371">
        <div className="flex items-start gap-3" data-id="element-372">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-373" />
          <span className="text-gray-700" data-id="element-374">8-week comprehensive program</span>
        </div>
        <div className="flex items-start gap-3" data-id="element-375">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-376" />
          <span className="text-gray-700" data-id="element-377">
            Live sessions with expert instructors
          </span>
        </div>
        <div className="flex items-start gap-3" data-id="element-378">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-379" />
          <span className="text-gray-700" data-id="element-380">
            Lifetime access to course materials
          </span>
        </div>
        <div className="flex items-start gap-3" data-id="element-381">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-382" />
          <span className="text-gray-700" data-id="element-383">
            Professional certificate upon completion
          </span>
        </div>
        <div className="flex items-start gap-3" data-id="element-384">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-385" />
          <span className="text-gray-700" data-id="element-386">Portfolio templates and tools</span>
        </div>
        <div className="flex items-start gap-3" data-id="element-387">
          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-388" />
          <span className="text-gray-700" data-id="element-389">
            Career support and job placement assistance
          </span>
        </div>
      </div>

      {!showEmailInput ? <button onClick={handleEnrollClick} className="w-full bg-blue-600 text-white font-semibold py-4 px-6 rounded-full hover:bg-blue-700 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 transform" data-id="element-390">
          Enroll Now - Limited Slots
        </button> : <div className="space-y-4" data-id="element-391">
          <div data-id="element-392">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-393">
              Enter your email to proceed
            </label>
            <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your.email@example.com" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none transition-colors duration-200" required data-id="element-394" />
          </div>
          <PaystackButton amount={150000} email={email} onSuccess={handlePaymentSuccess} onClose={handlePaymentClose} variant="primary" fullWidth data-id="element-395">
            Pay ₦150,000
          </PaystackButton>
          <button onClick={() => setShowEmailInput(false)} className="w-full text-gray-600 text-sm hover:text-gray-800 transition-colors duration-200" data-id="element-396">
            Cancel
          </button>
        </div>}

      <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-397">
        <div className="bg-green-50 rounded-lg p-4 border border-green-200" data-id="element-398">
          <p className="text-sm text-green-900 font-medium mb-2" data-id="element-399">
            🎓 Special Group Rates Available
          </p>
          <p className="text-xs text-green-800 mb-3" data-id="element-400">
            Organizations, schools, or groups interested in bulk purchase can
            get tailored pricing.
          </p>
          <a href="mailto:myskillzhq@gmail.com" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700 font-medium transition-colors duration-200" data-id="element-401">
            <Mail className="w-4 h-4" data-id="element-402" />
            myskillzhq@gmail.com
          </a>
        </div>
      </div>
    </div>;
}